<template>
  <div class="search-wrapper pxstrict">
    <!-- 搜索框 -->
    <div class="search-input-wrapper pxstrict">
      <div class="input-wrapper">
        <i class="i-search"></i>
        <!--请输入客户的旧机型号-->
        <input
          class="search-input"
          v-model="searchParams.keyWord"
          type="text"
          :placeholder="$t('tip.tip28')"
          @input="keywordChange"
        />
        <i class="i-clear" @click="clear" v-show="searchParams.keyWord"></i>
      </div>
    </div>
    <!-- 搜索列表 -->
    <div class="van-list-wrapper pxstrict" v-show="showSearchList">
      <van-list
        v-model="searchLoading"
        :finished="searchFinished"
        finished-text=""
        @load="onLoadSearch"
      >
        <div
          class="search-item"
          :key="`search-item-${item.productId}`"
          v-for="item in searchList"
          @click="go(item.productId)"
        >
          <span class="name">{{ item.name }}</span>
          <!-- <span :class="['name', item.alias ? 'name-has-alias' : '']">{{
            item.name
          }}</span>
          <span class="alias" v-if="item.alias">{{ item.alias }}</span> -->
        </div>
      </van-list>
      <div class="text-no" @click="goAddModel">
        <span>{{$t('feed.no')}}</span>
      </div>
    </div>
    <!--文本为：抱歉，没有找到对应的机型，请搜索其他机型或联系客服添加该机型。-->
    <div class="search-list-blank pxstrict" v-if="showSearchBlank" @touchmove.prevent>
      <span>{{$t('tip.tip34')}}</span>
      <div class="text-no" @click="goAddModel">
        <span>{{$t('feed.no')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Field, List } from "vant";

export default {
  data() {
    return {
      timer: null,
      searchParams: {
        keyWord: "",
        pageSize: 30,
        currentPage: 1,
      },
      searchList: [],
      searchLoading: false,
      searchFinished: false,
      loading: true,
    };
  },
  computed: {
    /**
     * 是否显示搜索列表
     */
    showSearchList() {
      return this.searchParams.keyWord && this.searchList.length !== 0;
    },
    /**
     * 是否显示空搜索提示
     */
    showSearchBlank() {
      return (
        this.searchParams.keyWord &&
        !this.loading &&
        this.searchList.length === 0
      );
    },
  },
  watch: {
    /**
     * 监听搜索列表是否展示，设置底层容器是否可以滚动
     */
    showSearchList: function (val) {
      if (val) {
        //展示则不可滚动
        document.body.style.overflow = "hidden";
      } else {
        //隐藏则可滚动
        document.body.style.overflow = "auto";
      }
    },
  },
  components: {
    "van-field": Field,
    "van-list": List,
  },
  methods: {
    /**
     * 清空搜索框
     */
    clear() {
      this.searchParams.keyWord = "";
    },
    /**
     * 搜索机型
     */
    search() {
      this.loading = true;
      this.$api.searchPhoneModel(this.searchParams).then((res) => {
        if (res.code === "0000") {
          this.loading = false;
          this.searchList = this.searchList.concat(res.data.list);
          this.searchLoading = false;
          if (res.data.nextPage === 0) {
            this.searchFinished = true;
          }
        }
      });
    },
    /**
     * 监听搜索词的变化
     */
    keywordChange(data) {
      let value = data.target.value;
      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.searchList = [];
      this.searchFinished = false;
      this.searchLoading = false;
      this.loading = true;
      this.searchParams.currentPage = 1;
      if (value) {
        this.timer = setTimeout(() => {
          this.search();
        }, 500);
      }
    },
    /**
     * 搜索列表上拉加载
     */
    onLoadSearch() {
      if (!this.searchFinished) {
        this.searchLoading = true;
        this.searchParams.currentPage++;
        this.search();
      }
    },

    /**
     * 跳转至设备属性页面
     * @param id
     */
    go(id) {
      let choosePhoneModel = Object.assign({}, this.$data);
      localStorage.setItem(
        "choose-phone-model",
        JSON.stringify(choosePhoneModel)
      );
      this.$router.push({
        name: "choose_device_properties",
        query: {
          id,
        },
      });
      //清空搜索词，使返回时能不显示搜索结果弹窗
      this.searchParams.keyWord = "";
    },

    // 跳转至添加新机型页面
    goAddModel() {
      this.$router.push({
        name: 'newModel'
      })
      this.clear()
    }
  },
};
</script>


<style lang="less" scoped>
// @import "../../../styles/reset.scss";
.search-input-wrapper.pxstrict {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  background: #fff;
  padding: 10px 20px;
  .input-wrapper {
    height: 34px;
    display: flex;
    align-items: center;
    border-radius: 5px;
    background: #f2f2f2;
    font-size: 13px;
    .i-search {
      @include bg("../../../assets/search");
      width: 15px;
      height: 15px;
      vertical-align: middle;
      margin: 0 10px;
    }
    .search-input {
      flex: 1;
      padding-right: 10px;
      background: #f2f2f2;
      .van-field__body {
        height: 100%;
      }
    }
    input::placeholder {
      font-size: 12px;
     }
    .i-clear {
      @include bg("../../../assets/search_clear");
      width: 12px;
      height: 12px;
      vertical-align: middle;
      margin-right: 10px;
    }
  }
}
.van-list-wrapper.pxstrict{
	top: 54px;
}
.van-list-wrapper {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 100;
  overflow: auto;
  padding: 0 13px;
  background: #fff;
  .search-item {
    height: 45px;
    line-height: 45px;
    padding: 0 10px;
    border-bottom: 1px solid #dce1ed;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    .name {
      @include singleEllipsis(100%);
    }
    .name-has-alias {
      @include singleEllipsis(225);
    }
    .alias {
      @include singleEllipsis(100);
      text-align: right;
      color: #808080;
      font-size: 14px;
    }
  }
}
.search-list-blank.pxstrict {
  position: fixed;
  left: 0;
  right: 0;
  top: 100px;
  bottom: 0;
  overflow: hidden;
  padding: 0 18px;
  font-size: 14px;
  line-height: 22px;
  background: #fff;
  z-index: 100;
}

.text-no {
  display: flex;
  justify-content: center;
  margin-top: 16px;
  color: #405FFF;
  cursor:pointer;
  font-size: 14px;
  margin-bottom: 33px;
}
</style>
